import _ from 'lodash'
import axios from 'axios'
import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import {
  PreparationState,
  Preparation,
  Quiz,
  Answer,
  QuizzesForTheStudent,
} from '@/store/lessons/preparation/types';
import moment from 'moment';

const actions: ActionTree<PreparationState, RootState> = {
  /**
   * Preparation取得
  */
  getPreparation: (
    { commit, dispatch, getters },
    lessonId: string,
  ) => axios.get(`/lessons/${lessonId}/preparation`)
    .then(async ({ data }) => {
      await Promise.all([
        ...data.students.map(({ studentId }: { studentId: string }) => dispatch('getStudentById', { studentId })),
      ])

      const preparation: Preparation = {
        course: {
          name: data.courseName,
        },
        university: {
          abbreviation: data.universityAbbreviation,
        },
        booth: {
          building: data.boothBuilding,
          room: data.boothRoom,
          number: data.boothNumber,
        },
        campus: {
          name: data.campusName,
        },
        level: {
          name: data.level,
        },
        period: data.period,
        unit: data.unit,
        date: moment(data.date, 'YYYYMMDD'),
        students: data.students.map((
          { studentId, quizzes }: { studentId: string, quizzes: any[] },
        ): QuizzesForTheStudent => ({
          student: getters.findStudentById(studentId),
          quizzes: _.chain(quizzes).map((q): Quiz => ({
            question: q.question,
            position: q.position,
            answers: _.map(q.answers, (a): Answer => ({
              choice: a.choice,
              isCorrect: a.isCorrect,
              isSelected: a.isSelected,
            })),
          })).sortBy(['position']).value(),
        })),
      }

      commit('gotPreparation', preparation)
    }),

};

export default actions;
